/*
 * Copyright (c) 2022 SARL SIGMA POLYNESIA
 */

import { useIntl } from 'react-intl'
import PageTitle from '../../../../client/js/components/PageTitle'
import useQueryParams from '../../../../client/js/hooks/useQueryParams'
import LeaseListCard from './LeaseListCard'
import { Container } from '@mantine/core'
import Page from '../../../../client/js/components/Page'

function LeaseListPage () {
  const intl = useIntl()

  const title = intl.formatMessage({
    id: 'rental_files',
    defaultMessage: 'Dossiers de location'
  })

  const [searchParams, setSearchParams] = useQueryParams()

  return (
    <Page>
      <Container size="xl">
        <PageTitle
          hidden
          title={title}
        />

        <LeaseListCard
          query={searchParams}
          onQueryChange={setSearchParams}
        />
      </Container>
    </Page>
  )
}

export default LeaseListPage
